import {Typography, Stack, Box} from '@mui/material';
import MainCard from "../../../Components/MainCard";
import SelectOrganisationPlanUpdate
    from "../../../assets/images/getting-started/subscribinginfo/SelectOrganisationUpdate.png";
import MultiEditProfile from "../../../assets/images/getting-started/subscribinginfo/MultiEditProfile.png";
import AddUser from "../../../assets/images/getting-started/subscribinginfo/AddUser.png";
import DeleteUserIcon from "../../../assets/images/getting-started/UserAddOns/DeleteUserIcon.png";
import ConfirmDeleteUser from "../../../assets/images/getting-started/UserAddOns/ConfirmDeleteUser.png";

function UserAddOns(){
    return (
        <MainCard>
            <Stack spacing={2.5}>
                <Typography variant="h4">
                    User Management
                </Typography>
                <Typography variant="body1">
                    Depending on the plan you have and number of user add-ons purchased you can follow the instructions
                    below to manage users.
                </Typography>
                <Typography variant="h6">
                    Adding Users
                </Typography>
                <Typography variant="body1">
                    As part of the Multi Organisation Plan, as well as User Add Ons purchased in the Single Organisation Plan, you can add users to your subscription.
                    To add users please follow the steps below:
                </Typography>
                <Typography variant="body1">
                    1. Select the Xero Organisation you would like to add additional Users to.
                    <Box
                        sx={{ position: 'relative', bottom: 0, right: 0 }}
                    >
                        <img style={{width:'100%', height: '100%'}} src={SelectOrganisationPlanUpdate} alt="Select Subscription" />
                    </Box>
                </Typography>
                <Typography variant="body1">
                    2. Navigate to the Edit Profile page.
                    <Box
                        sx={{ position: 'relative', bottom: 0, right: 0 }}
                    >
                        <img style={{width:'100%', height: '100%'}} src={MultiEditProfile} alt="Multi Organisation Edit Profile" />
                    </Box>
                </Typography>
                <Typography variant="body1">
                    3. Click the Users tab then enter the e-mail address and role of the user.
                    <Box
                        sx={{ position: 'relative', bottom: 0, right: 0 }}
                    >
                        <img style={{width:'100%', height: '100%'}} src={AddUser} alt="Add User" />
                    </Box>
                </Typography>
                <Typography variant="body1">
                    4. Click the Add User button.
                </Typography>
                <Typography variant="body1">
                    7. If the user does not have an account with Ikigai they will be sent a email with
                    temporary credentials. Upon initial sign in they will be prompted to create a new password.
                    The temporary credentials will be valid for 7 days only.
                </Typography>
                <Typography variant="h6">
                    Removing Users
                </Typography>
                <Typography variant="body1">
                    To remove users please follow the steps below:
                </Typography>
                <Typography variant="body1">
                    1. Select the Xero Organisation you would like to remove User from.
                    <Box
                        sx={{ position: 'relative', bottom: 0, right: 0 }}
                    >
                        <img style={{width:'100%', height: '100%'}} src={SelectOrganisationPlanUpdate} alt="Select Subscription" />
                    </Box>
                </Typography>
                <Typography variant="body1">
                    2. Navigate to the Edit Profile page.
                    <Box
                        sx={{ position: 'relative', bottom: 0, right: 0 }}
                    >
                        <img style={{width:'100%', height: '100%'}} src={MultiEditProfile} alt="Multi Organisation Edit Profile" />
                    </Box>
                </Typography>
                <Typography variant="body1">
                    3. Click the Users tab then click the delete icon in the Actions column of the user you want to remove.
                    <Box
                        sx={{ position: 'relative', bottom: 0, right: 0 }}
                    >
                        <img style={{width:'100%', height: '100%'}} src={DeleteUserIcon} alt="Delete User" />
                    </Box>
                </Typography>
                <Typography variant="body1">
                    4. A pop up will appear once you clicked the delete icon. To confirm removal of user click on the Delete button.
                    <Box
                        sx={{ position: 'relative', bottom: 0, right: 0 }}
                    >
                        <img style={{width:'100%', height: '100%'}} src={ConfirmDeleteUser} alt="Confirm Delete User" />
                    </Box>
                </Typography>
            </Stack>
        </MainCard>
    )
}

export default UserAddOns;